export const mypic = require('./mypic.png')
export const profile = require('./profile.jpg')
export const skillLight = require('./Skill-light.png')
export const skillDark = require('./Skill-dark.png')